(function(angular){
    'use strict';

    class OutreachTemplate {
        constructor(
        $scope,
        $timeout,
        $translate,
        $mdDialog,
        $mdToast,
        EmailTemplateService,
        mwBannerService,
        mwCustomToastService,
        VALIDATION_CONSTANTS,
        ContactManagerNavigationService,
        CoreUserService,
        OutreachService,
        mwCustomBannerService
        ) {
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.$translate = $translate;
            this.$mdDialog = $mdDialog;
            this.$mdToast = $mdToast;
            this.EmailTemplateService = EmailTemplateService;
            this.mwCustomToastService = mwCustomToastService;
            this.CoreUserService = CoreUserService;
            this.OutreachService = OutreachService;
            this.ContactManagerNavigationService = ContactManagerNavigationService;
            this.mwCustomBannerService = mwCustomBannerService;
            this.mwBannerService = mwBannerService;
            this.template = {};
            this.shouldValidateForm = false;

            this.EMAIL_ADDRESS_REGEX = VALIDATION_CONSTANTS.EMAIL_REGEX;
            this.currentUser = this.CoreUserService.getCurrent();
            this.isSaving = false;
            this.invalidTemplateBody = false;
            this.isBusy = false;
        }

        $onInit() {
            this.templateTitle = this.templateTitle || '';

            this.templateId = this.templateId || null;
            this.messageBodyText = this.templateBody || '';
            this.modalHeader = this.$translate.instant('icm-outreach__template--create-template-header');
            this.saveButton = this.$translate.instant('icm-outreach__template--save-changes-button');
            this.doneButton = this.$translate.instant('icm-outreach__template--done-button');
            this.previewButton = this.$translate.instant('icm-outreach__template--send-preview-button');

            this.saveToastMessage = this.$translate.instant('icm-outreach__template--save-toast-message');
            this.doneToastMessage = this.$translate.instant('icm-outreach__template--done-toast-message');
            this.closeDialogHeader = this.$translate.instant('icm-outreach__template--close-dialog-header');
            this.closeDialogBody = this.$translate.instant('icm-outreach__template--close-dialog-body');
            this.closeDialogOkButton = this.$translate.instant('icm-outreach__template--close-dialog-ok-button-text');
            this.closeDialogCancelButton = this.$translate.instant('icm-outreach__template--close-dialog-cancel-button-test');

            this.noNameError = this.$translate.instant('icm-outreach__template--no-name-error');
            this.maxLengthNameError = this.$translate.instant('icm-outreach__template--max-length-name-error');
            this.duplicateNameError = this.$translate.instant('icm-outreach__template--duplicate-name-error');
            this.alertBannerText = this.$translate.instant('icm-outreach__template--alert-banner-text');
            this.alertBannerRetry = this.$translate.instant('icm-outreach__template--alert-banner-retry');
            this.noBodyError = this.$translate.instant('icm-outreach__template--no-body-error');

            this.firstNamePlaceholderText = this.$translate.instant('icm-web-influencers-outreach-compose__tinymce-editor--first-name-placeholder');
            this.lastNamePlaceholderText = this.$translate.instant('icm-web-influencers-outreach-compose__tinymce-editor--last-name-placeholder');

            this.editorOptions = {
                /* jshint camelcase: false */
                extended_valid_elements: 'first_name,last_name',
                plugins: 'autolink autoresize image link lists textcolor code noneditable powerpaste',
                toolbar: 'fontselect | fontsizeselect | bold italic underline forecolor | alignleft alignright aligncenter alignjustify | bullist numlist outdent indent | icm_mailMerge icm_imageUploadV5 link code',
                link_assume_external_targets: true
            };
        }

        updateEditorBusy(isBusy) {
          this.isBusy = isBusy;

          this.$timeout(function applyChanges() {
            this.$scope.$apply();
          }.bind(this), 0);
        }

        clearFormErrors() {
            this.shouldValidateForm = false;
            if (this.$scope.templateForm) {
                this.$scope.templateForm.templateTitle.$setValidity('duplicate', true);
            }
            this.isSaving = false;
            this.invalidTemplateBody = false;
        }

        showPlainAlertBanner(alertMessage){
            this.mwBannerService.open({
                attachTo: angular.element(document.getElementsByClassName('mw-flexi-modal')[0]),
                template: `
                  <mw-banner class="outreach-template-alert-banner" type="'alert'" on-close="$ctrl.close()">
                      {{$ctrl.alertBannerText}}
                  </mw-banner>
                `,
                controller: class BannerPanel {
                    constructor(mdPanelRef) {
                        'ngInject';

                        this.alertBannerText = alertMessage;
                        this.mdPanelRef = mdPanelRef;
                    }

                    close() {
                        this.mdPanelRef.close();
                    }
                }
            });
        }

        openAlertBanner(retryCallback) {
            const outreachTemplateController = this;
            const attachTo = angular.element(document.getElementsByClassName('mw-flexi-modal')[0]);

            this.mwCustomBannerService.alertWithRetry(this.alertBannerText, retryCallback, null, outreachTemplateController, attachTo, true);
        }

        saveTemplateNoCallback(){
            this.shouldValidateForm = true;
            const templateId = this.templateId;
            const templateName = this.templateTitle;
            const templateBody = this.messageBodyText;
            if(this.$scope.templateForm.$invalid) {
                return Promise.reject();
            } 
            else if (templateBody.length === 0) {
                this.invalidTemplateBody = true;
                return Promise.reject();
            }
            else {
                if(!templateId) {
                    return this.EmailTemplateService.createTemplate(templateName, templateBody)
                        .then((result) => {
                            return Promise.resolve(result);
                        })
                        .catch((error) => {
                            this.handleError(error, this.save);
                            return Promise.reject();
                        });
                } else {
                    return this.EmailTemplateService.updateTemplate(templateId, templateName, templateBody)
                        .then((result) => {
                            return Promise.resolve(result);
                        })
                        .catch((error) => {
                            this.handleError(error, this.save);
                            return Promise.reject();
                        });
                }
            }
        }

        saveTemplate(retryCallback) {
            this.shouldValidateForm = true;

            const templateId = this.templateId;
            const templateName = this.templateTitle;
            const templateBody = this.messageBodyText;
            if(this.$scope.templateForm.$invalid) {
                return Promise.reject();
            } 
            else if (templateBody.length === 0) {
                this.invalidTemplateBody = true;
                return Promise.reject();
            }
            else {
                if(!templateId) {
                    return this.EmailTemplateService.createTemplate(templateName, templateBody)
                        .then((result) => {
                            this.templateId = result.data.templateId;

                            this.onCallback();
                            return Promise.resolve(result);
                        })
                        .catch((error) => {
                            this.handleError(error, retryCallback);
                            return Promise.reject();
                        });
                } else {
                    return this.EmailTemplateService.updateTemplate(templateId, templateName, templateBody)
                        .then((result) => {
                            this.onCallback();
                            return Promise.resolve(result);
                        })
                        .catch((error) => {
                            this.handleError(error, retryCallback);
                            return Promise.reject();
                        });
                }
            }
        }

        previewTemplate() {
            if(this.approvedSenders.length > 0){
                this.showPreviewEmailModal();
            } else {
                this.showNoApprovedSenders();
            }
        }

        showNoApprovedSenders() {
            this.$mdDialog.show(
                this.$mdDialog.mwConfirm()
                    .title(this.$translate.instant('icm-outreach__template--preview-dialog-title'))
                    .textContent(this.$translate.instant('You need to set up your email account before you can send email.'))
                    .ok(this.$translate.instant('icm-outreach__template--preview-email-config-button'))
                    .cancel(this.$translate.instant('Cancel'))
                    .multiple(true)
                    .parent(angular.element(document.getElementsByClassName('mw-flexi-modal')[0]))
            ).then(
                () => {
                    this.saveTemplateNoCallback().then(function(){
                        this.ContactManagerNavigationService.redirectToFairhairWeb('/settings/email');
                    }.bind(this));
                }
            );
        }

        showPreviewEmailModal() {
            let _this = this;
            this.hasFirstNameMailMergeField = this.messageBodyText.indexOf(this.firstNamePlaceholderText) > -1;
            this.hasLastNameMailMergeField = this.messageBodyText.indexOf(this.lastNamePlaceholderText) > -1;
            this.$mdDialog.show({
                bindToController: true,
                targetEvent: event,
                locals: {
                    EMAIL_ADDRESS_REGEX: this.EMAIL_ADDRESS_REGEX,
                    hasFirstNameMailMergeField: this.hasFirstNameMailMergeField,
                    hasLastNameMailMergeField: this.hasLastNameMailMergeField,
                    data: {
                        email: this.currentUser.email
                    },
                    cancelDialog: function() {
                        _this.$mdDialog.cancel();
                    },
                    approvedSenders: this.approvedSenders,
                    okDialog: function(data) {
                        _this.sendTemplatePreview(data);
                        _this.$mdDialog.hide();
                    }
                },
                template: `
                    <md-dialog id="icm-outreach-template-preview-modal" class="mw-mini-modal mw-mini-modal--wide" aria-label="" layout="column">
                        <mw-outreach-template-preview-modal class="mw-mini-modal-wrapper" layout="column" data="$ctrl.data" email-pattern="$ctrl.EMAIL_ADDRESS_REGEX" show-first-name-field="$ctrl.hasFirstNameMailMergeField" show-last-name-field="$ctrl.hasLastNameMailMergeField" ok-callback="$ctrl.okDialog(data)" cancel-callback="$ctrl.cancelDialog()" approved-sender-array="$ctrl.approvedSenders"></mw-outreach-template-preview-modal>
                    </md-dialog>
                `,
                parent: (angular.element(document.getElementsByClassName('mw-flexi-modal')[0])),
                multiple: true,
                // This is a globally available controller for the purposes of attaching locals for data binding
                controller: 'MwMiniModalDialogController',
                controllerAs: '$ctrl'
            });
        }

        sendTemplatePreview(data) {
            var senderData = JSON.parse(data.sender),
                sender = senderData.payloadEmail || '',
                senderId = senderData.id || '',
                recipient = {
                    private : true,
                    email : data.email,
                    name : data.email,
                    lastName: data.lastName,
                    firstName: data.firstName,
                    id : null
                },
                payload = {
                    recipients: [recipient],
                    mediaLists: [],
                    subject: this.templateTitle + ' (' + this.$translate.instant('icm-outreach__email-preview--preview-subject-tag') + ')',
                    bodyHtml: this.messageBodyText,
                    fromAddress: sender,
                    userLanguage: this.currentUser.language,
                    approvedSenderId: senderId,
                    firstNamePlaceholder: this.firstNamePlaceholderText,
                    lastNamePlaceholder: this.lastNamePlaceholderText,
                    sendImmediately: true,
                    isPreview: true,
                    attachments: [],
                    templateId: this.templateId || ''
                };

            this.OutreachService.outreach(payload, this.fileUploadList)
                .then(() =>{
                    this.$mdToast.show(
                        this.mwCustomToastService.simpleTimedClosable(this.$translate.instant('icm-outreach__template--preview-dialog-success-toast', {recipient: recipient.email}))
                    );
                })
                .catch(function onError() {
                    this.showPlainAlertBanner(this.$translate.instant('icm-outreach__template--alert-preview-banner-text'));
                }.bind(this));
        }

        handleError(error, retryCallback) {
            if (error && error.data && error.data.code) {
                switch(error.data.code) {
                    case 'ER_DUP_ENTRY':
                        this.$scope.templateForm.templateTitle.$setValidity('duplicate', false);
                        break;
                    default:
                        this.openAlertBanner(retryCallback);
                        break;
                }
            } else {
                this.openAlertBanner(retryCallback);
            }
        }

        close(ev) {
            this.$mdDialog.show(
                this.$mdDialog.mwConfirm()
                    .title(this.closeDialogHeader)
                    .textContent(this.closeDialogBody)
                    .ok(this.closeDialogOkButton)
                    .cancel(this.closeDialogCancelButton)
                    .targetEvent(ev)
            ).then(
                () => {
                    this.$mdDialog.cancel();
                }
            );
        }

        save() {
            const outreachTemplateController = this;
            this.isSaving = true;

            this.saveTemplate(this.save).then(() => {
                this.$mdToast.show(
                    this.mwCustomToastService.simpleTimedClosable(outreachTemplateController.saveToastMessage)
                );
                this.isSaving = false;
            });
        }

        saveAndClose() {
            const outreachTemplateController = this;
            this.isSaving = true;

            this.saveTemplate(this.saveAndClose).then(() => {
                this.$mdDialog.cancel();

                this.$mdToast.show(
                    this.mwCustomToastService.simpleTimedClosable(outreachTemplateController.doneToastMessage)
                );
            });
        }
    }

    angular
        .module('MW.Influencers.OutreachTemplate', [
            'ngMaterial',
            'MW.Influencers.EmailTemplateService',
            'mwAppComponents',
            'MW.ContactManager.CustomToastService',
            'MW.Framework.ValidationConstants',
            'MW.ContactManager.ContactManagerNavigationService',
            'MW.Framework.CoreUserService',
            'MW.ContactManager.OutreachService',
            'MW.ContactManager.MwOutreachTemplatePreviewModal',
            'MW.ContactManager.CustomBannerService'
        ])
        .component('mwOutreachTemplate', {
            controller: [
                '$scope',
                '$timeout',
                '$translate',
                '$mdDialog',
                '$mdToast',
                'EmailTemplateService',
                'mwBannerService',
                'mwCustomToastService',
                'VALIDATION_CONSTANTS',
                'ContactManagerNavigationService',
                'CoreUserService',
                'OutreachService',
                'mwCustomBannerService',
                OutreachTemplate
            ],
            bindings: {
                templateId: '<',
                templateTitle: '<',
                templateBody: '<',
                approvedSenders: '<',
                onCallback: '&'
            },
            template: `
            <md-dialog class="mw-flexi-modal" aria-label="Fleximodal" layout="column">
                <mw-flexi-modal-header on-close="$ctrl.close()">{{$ctrl.modalHeader}}</mw-flexi-modal-header>
                <md-dialog-content class="mw-flex-padding" layout="column" flex>
                    <form name="templateForm">
                        <input type="text" id="initFocus" style="display: none;" />
                        <div class="content-wrapper">
                            <md-card>
                                <md-card-title>
                                    <span translate>icm-outreach__template--template-details-header
                                </md-card-title>
                                <md-card-content layout="row" layout-align="space-around">
                                    <md-input-container md-is-error="$ctrl.shouldValidateForm && !templateForm.templateTitle.$valid">
                                        <label translate>icm-outreach__template--template-name</label>
                                        <input ng-change="$ctrl.clearFormErrors()" ng-model="$ctrl.templateTitle" name="templateTitle" required="required" md-maxlength="75" />
                                        <div ng-messages="templateForm.templateTitle.$error">
                                            <div ng-message="required">{{$ctrl.noNameError}}</div>
                                            <div ng-message="md-maxlength">{{$ctrl.maxLengthNameError}}</div>
                                            <div ng-message="duplicate">{{$ctrl.duplicateNameError}}</div>
                                        </div>
                                    </md-input-container>
                                </md-card-content>
                            </md-card>
                            <h3 translate>icm-outreach__template--template-content-header</h3>
                            <div class="textEditor">
                                <textarea class='editor' tinymce-editor-v5 tinymce-editor-options="$ctrl.editorOptions", ng-model="$ctrl.messageBodyText", stick-to=".application-canvas", busy-callback="$ctrl.updateEditorBusy(isBusy)" ng-change="$ctrl.clearFormErrors()"></textarea>
                            </div>
                            <div>
                                <span class="template-error" ng-if="$ctrl.invalidTemplateBody">{{$ctrl.noBodyError}}</span>
                                <span flex></span>
                                <md-button ng-disabled="$ctrl.messageBodyText.length === 0 || $ctrl.templateTitle.length ===0"ng-click="$ctrl.previewTemplate()" class="preview-btn mw-button mw-button--outlined right">{{$ctrl.previewButton}}</md-button>
                            </div>
                            <div flex></div>
                        </div>
                    </form>
                </md-dialog-content>
                <md-dialog-actions layout="row">
                    <md-button class="mw-button mw-button--outlined" ng-click="$ctrl.save()" ng-disabled="$ctrl.isSaving || $ctrl.isBusy">{{$ctrl.saveButton}}</md-button>
                    <md-button class="mw-button md-primary" ng-click="$ctrl.saveAndClose()" ng-disabled="$ctrl.isSaving || $ctrl.isBusy">{{$ctrl.doneButton}}</md-button>
                </md-dialog-actions>
            </md-dialog>
            `
        });
})(angular);